import React from 'react';

export const AddIcon: React.FC = () => (
	<svg width='2.2rem' height='2.2rem' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M11 6V16' stroke='currentColor' strokeWidth='1.5' />
		<path d='M6 11L16 11' stroke='currentColor' strokeWidth='1.5' />
		<circle cx='11' cy='11' r='10' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
